export const modifyMemberInfoEn = {
    xunjiadang:'Membership information',
    touxiang:'Head portrait',
    nicheng:'Nickname',
    zhengshixingming:'memberName',
    xingbie:'Gender',
    nan:'male',
    nv:'female',
    zhuzhudi:'Residence',
    qingxuanzhe:'Choose',
    xiangxidizhi:'Address',
    shoujihaoma:'Phone',
    youxiang:'Email',
    weixinhao:'Wechat',
    yibanding:'Bound',
    weibangding:'Unbound',
    jiebang:'Untying',
    huiyuanxinxixiougai:'Member information - modification review',
    fanhui:'back',
    niyichenggong:'You have successfully uploaded the relevant information, and we will review it with in 7 working days!'
}


// WEBPACK FOOTER //
// ./src/lang/member/modifyMemberInfo/modifyMemberInfoEn.js